import React, { useState } from 'react';
import { compose } from 'recompose';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import { lightTheme } from '../../layout/MyLayout';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { translate, showNotification } from 'react-admin';
import { connect } from 'react-redux';
import { isPermissiveAsAccountManager } from '../../const/Role';

const contentStyle = { marginLeft: '5em' };

const authPageOpen = () => {
  window.open(process.env.REACT_APP_RSB_API_ENDPOINT + '/auth-app/outlook', null, 'width=1000, height=800');
};

const AppSettingConfig = ({ permissions, config, getConfig, updateConfig, translate, showNotification }) => {
  const [isFocus, setIsFocus] = useState(true);

  const onFocus = async () => {
    if (!isFocus) {
      await getConfig();
    }
    setIsFocus(true);
  };

  const onBlur = () => {
    setIsFocus(false);
  };

  const onDelink = async e => {
    var options = {
      method: 'POST',
      credentials: 'include',
      mode: 'cors',
    };
    var request = new Request(process.env.REACT_APP_RSB_API_ENDPOINT + '/auth-app/outlook/delink');
    fetch(request, options)
      .then(() => {
        updateConfig({
          ...config,
          isAuthenticated: false,
          isEnableAppAuth: false,
        });
      })
      .catch(e => showNotification('ra.message.error', 'warning'));
  };

  return (
    <MuiThemeProvider theme={lightTheme}>
      <Card onFocus={onFocus} onBlur={onBlur}>
        <List>
          <ListItem>
            <ListItemText primary={translate('appAuthConfig.title')} />
          </ListItem>
          {isPermissiveAsAccountManager(permissions) && (
            <ListItem style={contentStyle}>
              <Button
                variant="contained"
                color="primary"
                onClick={authPageOpen}
                style={{ textTransform: 'none', minWidth: 250 }}
              >
                {config.isAuthenticated ? translate('appAuthConfig.changeUser') : translate('appAuthConfig.m365')}
              </Button>
            </ListItem>
          )}
          <ListItem style={contentStyle}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <ListItemText
                primary={translate('appAuthConfig.linkState')}
                secondary={
                  config.isAuthenticated
                    ? `${translate('appAuthConfig.linked')} (${config.impersonatedUserId || translate('appAuthConfig.noLinkedUser')})`
                    : `　${translate('appAuthConfig.unlinked')}`
                }
                style={{ maxWidth: 500, overflowWrap: 'break-word' }}
              />
              {isPermissiveAsAccountManager(permissions) && config.isAuthenticated && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onDelink}
                  style={{ minWidth: 120, height: 30, marginLeft: 30 }}
                >
                  {translate('appAuthConfig.delink')}
                </Button>
              )}
            </div>
          </ListItem>
        </List>
      </Card>
    </MuiThemeProvider>
  );
};

const enhance = compose(translate, connect(undefined, { showNotification }));
export default enhance(AppSettingConfig);
